exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.glyphicon-triangle-top:before {\n  content: \"\\F106\" !important; }\n\n.customPagination {\n  padding-right: 15px !important; }\n\n.glyphicon-triangle-bottom:before {\n  content: \"\\F107\" !important; }\n\n.customImage {\n  margin-right: -14px; }\n\n.imageWork {\n  height: 40px;\n  width: 57px; }\n\n.thsearch {\n  width: 20%; }\n\n.thnosearch {\n  width: 20% !important;\n  padding-bottom: 45px !important; }\n\n.downloadBtn {\n  margin-top: 1em;\n  float: right;\n  margin-right: 1em; }\n\n.thnoitem {\n  width: 10%; }\n\n.searchinput :hover {\n  background-color: #ccc !important; }\n\n.searchdate :hover {\n  background-color: #ccc !important; }\n\n.searchdate-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  .searchdate-wrapper .searchdate {\n    width: 5rem;\n    font-size: 11px; }\n  .searchdate-wrapper .searchdate-year {\n    width: 7rem;\n    font-size: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/menu-items/menu-items.component.scss
// module id = ../../../../../src/app/routes/restaurant/menu-items/menu-items.component.scss
// module chunks = main